/* eslint-disable import/prefer-default-export */
import PythonEditor from './components/PythonEditor.react';

export {
    PythonEditor
};
